/* Choice Traders — lightweight theme JS (no dependencies) */
(function () {
  'use strict';

  function on(sel, evt, handler, root) {
    (root || document).addEventListener(evt, function (e) {
      var el = e.target.closest(sel);
      if (el) handler(e, el);
    });
  }

  /* Header: search + mobile nav toggles */
  on('[data-toggle]', 'click', function (e, btn) {
    e.preventDefault();
    var target = document.querySelector(btn.getAttribute('data-toggle'));
    if (!target) return;
    var open = target.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var input = target.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  });

  /* Product gallery thumbnails */
  on('[data-thumb]', 'click', function (e, thumb) {
    e.preventDefault();
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = thumb.getAttribute('data-full');
    main.srcset = '';
    main.alt = thumb.getAttribute('data-alt') || main.alt;
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* Quantity steppers */
  on('[data-qty]', 'click', function (e, btn) {
    e.preventDefault();
    var wrap = btn.closest('.ct-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var value = (parseInt(input.value, 10) || min) + step;
    input.value = value < min ? min : value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Variant selection on product page */
  function initVariants() {
    document.querySelectorAll('[data-variant-form]').forEach(function (form) {
      var select = form.querySelector('[data-variant-select]');
      if (!select) return;
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var priceEl = form.querySelector('[data-variant-price]');
        var btn = form.querySelector('[data-add-button]');
        if (priceEl && option.dataset.price) priceEl.innerHTML = option.dataset.price;
        if (btn) {
          var available = option.dataset.available === 'true';
          btn.disabled = !available;
          btn.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* Quick add via Shopify Cart AJAX API — real cart, no fake state */
  on('[data-quick-add]', 'submit', function (e, form) {
    e.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = '...'; }
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        if (button) button.textContent = button.dataset.labelAdded || 'Added';
        setTimeout(function () { if (button) { button.textContent = original; button.disabled = false; } }, 1600);
      })
      .catch(function () {
        if (button) { button.textContent = original; button.disabled = false; }
        form.submit();
      });
  });

  /* Wishlist-style visual toggle (local only) */
  on('[data-wish]', 'click', function (e, btn) {
    e.preventDefault();
    var id = btn.getAttribute('data-wish');
    var list = JSON.parse(localStorage.getItem('ct-wishlist') || '[]');
    var i = list.indexOf(id);
    if (i > -1) { list.splice(i, 1); } else { list.push(id); }
    localStorage.setItem('ct-wishlist', JSON.stringify(list));
    btn.classList.toggle('is-active', i === -1);
  });

  function restoreWishlist() {
    var list = JSON.parse(localStorage.getItem('ct-wishlist') || '[]');
    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      if (list.indexOf(btn.getAttribute('data-wish')) > -1) btn.classList.add('is-active');
    });
  }

  /* Auto-submit sort / filter forms */
  on('[data-auto-submit]', 'change', function (e, el) {
    var form = el.closest('form');
    if (form) form.submit();
  });

  /* Scroll reveal */
  function initReveal() {
    var els = document.querySelectorAll('.ct-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.transitionDelay = (entry.target.dataset.delay || 0) + 'ms';
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { initVariants(); initReveal(); restoreWishlist(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
